import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { Observable } from 'rxjs';
import { SvcDialogConfig } from './models/svc-dialog-config';
import { SvcDialogSizesWidth } from './models/svc-dialog-sizes';
import { SvcImagesViewerConfig, SvcImagesViewerItem, SvcImagesViewerModalComponent } from '../modals/svc-modal-image-viewer/svc-images-viewer-modal.component';
import { SvcConfirmDialogComponent } from './components/svc-confirm-dialog/svc-confirm-dialog.component';
import { SvcWarningDialogComponent } from './components/svc-warning-dialog/svc-warning-dialog.component';
import { SvcAlertDialogComponent } from './components/svc-alert-dialog/svc-alert-dialog.component';
import { SvcCopilotConfirmDialogComponent } from './components/svc-copilot-confirm-dialog/svc-copilot-confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SvcDialogService {
  constructor(private _matDialog: MatDialog) {}

  open<T>(component: ComponentType<T> | TemplateRef<T>, config?: SvcDialogConfig): MatDialogRef<T> {
    if (config?.size) {
      config.minWidth = SvcDialogSizesWidth[config.size];
      config.maxWidth = SvcDialogSizesWidth[config.size];
    }
    return this._matDialog.open(component, config);
  }

  openImage(imagesUrl: string | SvcImagesViewerItem[], config?: SvcImagesViewerConfig): void {
    this._matDialog.open(SvcImagesViewerModalComponent, {
      data: { imagesUrl, config },
      panelClass: ['cdk-ignore-hidden'],
    });
  }

  openConfirm(
    text: string,
    config?: {
      title?: string;
      okText?: string;
      cancelText?: string;
      hideCloseButton?: boolean;
    }
  ): Observable<boolean> {
    return this._matDialog
      .open(SvcConfirmDialogComponent, {
        data: {
          text,
          title: config?.title,
          okText: config?.okText,
          cancelText: config?.cancelText,
          hideCloseButton: config?.hideCloseButton,
        },
        width: '100%',
        maxWidth: '600px',
        panelClass: ['cdk-ignore-hidden'],
      })
      .afterClosed();
  }

  public openWarning(
    text: string,
    config?: {
      title?: string;
      buttonText?: string;
    }
  ): Observable<void> {
    return this._matDialog
      .open(SvcWarningDialogComponent, {
        data: {
          text,
          ...config,
        },
        width: '100%',
        maxWidth: '600px',
        panelClass: ['cdk-ignore-hidden'],
      })
      .afterClosed();
  }

  public openAlert(
    text: string,
    config?: {
      title?: string;
      buttonText?: string;
    }
  ): Observable<void> {
    return this._matDialog
      .open(SvcAlertDialogComponent, {
        data: {
          text,
          ...config,
        },
        width: '100%',
        maxWidth: '600px',
        panelClass: ['cdk-ignore-hidden', 'svc-alert-dialog'],
      })
      .afterClosed();
  }

  openCopilotConfirm(
    text: string,
    config?: {
      title?: string;
      okText?: string;
      cancelText?: string;
      hideCloseButton?: boolean;
    }
  ): Observable<boolean> {
    return this._matDialog
      .open(SvcCopilotConfirmDialogComponent, {
        data: {
          text,
          title: config?.title,
          okText: config?.okText,
          cancelText: config?.cancelText,
          hideCloseButton: config?.hideCloseButton,
        },
        width: '100%',
        maxWidth: '600px',
        panelClass: ['cdk-ignore-hidden'],
      })
      .afterClosed();
  }

  public closeAll(): void {
    this._matDialog.closeAll();
  }
}
